import Axios from "axios";
import config from "configs/config";
import getText from "Translator";

const returnError = (err, lang) => {
  console.log(err);
  const data = {
    success: false,
    code: 5001,
    message: getText("generalerror", lang),
  };
  return data;
};

export const getColleaguesFromServer = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/auth/getcolleagueslist/";
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const createNewpassword = async (lang, authData) => {
  try {
    const url = `${config.apiserver}/auth/createnewpassword/`;
    console.log(url);
    const user = await Axios.post(url, authData);
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const login = async (lang, authData) => {
  try {
    const url = `${config.apiserver}/auth/login/`;
    console.log(url);
    const user = await Axios.post(url, authData);
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const register = async (lang, newUser) => {
  try {
    const url = `${config.apiserver}/auth/register/`;
    const user = await Axios.post(url, newUser);
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getUser = async (lang, id, token) => {
  try {
    const url = `${config.apiserver}/auth/getuser/${id}`;
    console.log(url);
    const user = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const activation = async (lang, newData, token) => {
  try {
    const url = `${config.apiserver}/admin/updateuseractivation/`;

    const res = await Axios.put(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });

    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const updateActiveState = async (newData, token) => {
  try {
    let url = config.apiserver + "/auth/updateActiveState";
    console.log(url);
    let user = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    let data = {
      success: false,
    };
    return data;
  }
};
export const deleteUser = async (newData, controller) => {
  try {
    const url = `${config.apiserver}/auth/deleteuser/`;
    const responce = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });

    return responce.data;
  } catch (err) {
    return returnError(err, controller.lang);
  }
};

export const updatePermission = async (lang, body, token) => {
  try {
    const url = `${config.apiserver}/auth/updatepermission`;
    const user = await Axios.post(url, body, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const completProfile = async (lang, profile, picture, token) => {
  try {
    const formData = new FormData();

    // formData.append("picture", picture);
    // formData.append("name", profile.name);
    // formData.append("code", profile.code);
    // formData.append("age", profile.age);
    // formData.append("gender", profile.gender);
    // formData.append("speciality", profile.speciality);
    // formData.append("city", profile.city);
    // formData.append("howToInform", profile.howToInform);
    // formData.append("nationality", profile.nationality);
    // formData.append("institution", profile.institution);
    const url = `${config.apiserver}/app/auth/completedashboradprofile/`;
    console.log(url);
    const data = await Axios.post(url, profile, {
      headers: {
        // "Content-Type": "multipart/form-data",
        "x-access-token": token,
      },
    });
    return data.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getSpecialities = async (lang) => {
  try {
    const url = `${config.apiserver}/specialities`;
    const specialities = await Axios.get(url);
    return specialities.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getCountries = async (lang) => {
  try {
    const url = `${config.apiserver}/countries`;
    const countries = await Axios.get(url);
    return countries.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getProfile = async (lang, token) => {
  try {
    const url = `${config.apiserver}/getprofile`;
    const user = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });

    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const changeUserRole = async (lang, newDate, token) => {
  try {
    const url = `${config.apiserver}/admin/upateuserrole/`;
    const user = await Axios.put(url, newDate, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const changeUserActiveMode = async (lang, id, mode, token) => {
  try {
    const url = `${config.apiserver}/admin/changeuseractivemode/${lang}/${id}/${mode}`;
    const user = await Axios.put(url, null, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getPassword = async (lang, id, token) => {
  try {
    const url = `${config.apiserver}/auth/getpassword/${lang}/${id}`;
    const user = await Axios.put(url, null, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getUsersList = async (datas, controller) => {
  try {
    const url = `${config.apiserver}/auth/users/`;
    console.log(url);
    const user = await Axios.post(url, datas, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, controller.lang);
  }
};
export const getUsersChart = async (lang, token) => {
  try {
    const url = `${config.apiserver}/app/userschart/`;

    const user = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const addUserToGroup = async (lang, newUserGroup, token) => {
  try {
    const url = `${config.apiserver}/admin/addusertogroup/`;
    const result = await Axios.put(url, newUserGroup, {
      headers: {
        "x-access-token": token,
      },
    });
    console.log("00000000", result);
    return result.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
